module.exports = __webpack_public_path__ + "media/images/icon/navigation/dashboard-active-5fee614c3b13bf208fb35b31db7ef24f.svg";